export default __webpack_public_path__ + "static/media/portfolio-100.f141b035.jpg";